export default "__VITE_ASSET__DTTV90QC__"